// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{margin:0;padding:0}#app{overflow:hidden}[v-cloak]{display:none}::-webkit-scrollbar{width:0 !important}", "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":"AACA,EACE,QAAA,CACA,SAAA,CAEF,KACE,eAAA,CAEF,UACE,YAAA,CAGF,oBACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
